export default __webpack_public_path__ + "static/media/swf-banner-tablet.830d0ca0.jpg";